import React from 'react';

interface HorizontalDotsProps {
    fill?: string;
    width?: number;
    height?: number;
}

export const HorizontalDots = ({
    fill = '#323232',
    width = 16,
    height = 16,
}: HorizontalDotsProps) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="4" cy="8" r="1" fill={fill} />
        <circle cx="7.99951" cy="8" r="1" fill={fill} />
        <circle cx="11.9995" cy="8" r="1" fill={fill} />
    </svg>
);
